import Vue from 'vue'
import VueRouter from 'vue-router'
import AccessToken from '@/utils/accessToken'
import ObservationPointData from '@/views/viewer/observationPointData'

import MainViewer from '@/views/viewer/main'
import Login from '@/views/common/login'
import Invitation from '@/views/common/invitation'
import NoAccess from '@/views/common/no-access.vue'
import ForgotPassword from '@/views/common/forgot-password.vue'

import ObservationPointDatasourceAdmin from '@/views/admin/observationPointData.vue'
import ListObservationPointAdmin from '@/views/admin/listObservationPoint.vue'
import ListUserAdmin from '@/views/admin/listUser.vue'
import ImportDataAdmin from '@/views/admin/importData.vue'
import AdminHomepage from '@/views/admin/home.vue'

import Config from '@/config.js'

Vue.use(VueRouter)

const basePath = process.env.NODE_ENV === 'development' ? '' : ''

const beforeEnterUser = (to, from, next) => {
  if (AccessToken.get() === null || !AccessToken.get().isLogged()) return next({ name: 'login', query: to.query })
  if (AccessToken.get() !== null && (!AccessToken.get().hasRight('strates_viewer'))) return next({ name: 'no-access' })
  return next()
}

const beforeEnterOperator = (to, from, next) => {
  if (AccessToken.get() === null || !AccessToken.get().isLogged()) return next({ name: 'login', query: to.query })
  if (AccessToken.get() !== null && (!AccessToken.get().hasRight('strates_operator'))) return next({ name: 'no-access' })
  return next()
}

const routes = [
  {
    path: `${basePath}`,
    name: 'home',
    component: MainViewer,
    beforeEnter: beforeEnterUser
  },
  {
    path: `${basePath}/login`,
    name: 'login',
    component: Login
  },
  {
    path: `${basePath}/forgot-password`,
    name: 'forgot-password',
    component: ForgotPassword
  },
  {
    path: `${basePath}/invitation/:hashCode`,
    name: 'invitation',
    component: Invitation
  },
  {
    path: `${basePath}/403`,
    name: 'no-access',
    component: NoAccess
  },
  {
    path: `${basePath}/observation-point/:id/data`,
    name: 'observation-point-data',
    component: ObservationPointData,
    beforeEnter: beforeEnterUser
  },
  {
    path: `${basePath}/admin`,
    name: 'admin-homepage',
    component: AdminHomepage,
    beforeEnter: (to, from, next) => {
      if (AccessToken.get() === null || !AccessToken.get().isLogged()) return next({ name: 'login', query: to.query })
      if (AccessToken.get() !== null && !(AccessToken.get().hasRight('mgmt_users') || AccessToken.get().hasRight('strates_operator'))) return next({ name: 'no-access' })
      return next()
    }
  },
  {
    path: `${basePath}/admin/observation-point/:id/data`,
    name: 'admin-observation-point-data',
    component: ObservationPointDatasourceAdmin,
    beforeEnter: beforeEnterOperator
  },
  {
    path: `${basePath}/admin/observation-point`,
    name: 'admin-observation-points',
    component: ListObservationPointAdmin,
    beforeEnter: beforeEnterOperator
  },
  {
    path: `${basePath}/admin/import-data`,
    name: 'admin-import-data',
    component: ImportDataAdmin,
    beforeEnter: beforeEnterOperator
  },
  {
    path: `${basePath}/admin/user`,
    name: 'admin-users',
    component: ListUserAdmin,
    beforeEnter: (to, from, next) => {
      if (AccessToken.get() === null || !AccessToken.get().isLogged()) return next({ name: 'login', query: to.query })
      if (AccessToken.get() !== null && (!AccessToken.get().hasRight('mgmt_users'))) return next({ name: 'no-access' })
      return next()
    }
  },
  {
    path: '*',
    redirect: basePath
  }
]
const router = new VueRouter({
  mode: 'history',
  base: Config.frontendBaseUrl,
  routes
})

export default router
